export default __webpack_public_path__ + "static/media/logo-bigode.1544394d.svg";